import React, { useEffect, useState } from 'react';
import './imports.css';
import { useTranslation } from 'react-i18next';
import { Alert } from '../ui';
import { workerStatus } from './importsApi';

export const CRONTAB_LINE = '* * * * * cd /var/www/inventorium/backend && php bin/worker.php >> storage/worker.log 2>&1';

/**
 * For administrators: a warning when no background worker has run for 5
 * minutes (phase 4 §6.1) — imports and fills then wait, so a missing crontab
 * line shows here instead of failing silently.
 */
function WorkerWarning() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let gone = false;
    workerStatus().then(answer => { if (!gone) setStatus(answer); }).catch(() => {});
    return () => { gone = true; };
  }, []);
  if (!status || status.alive) return null;
  return (
    <Alert tone="warning" title={t('jobs.noWorker.title')} className="worker-warning">
      <p>{status.last_seen ? t('jobs.noWorker.since', { date: new Date(status.last_seen).toLocaleString() }) : t('jobs.noWorker.never')}</p>
      <p>{t('jobs.noWorker.admin')}</p>
      <code className="worker-warning__cron">{CRONTAB_LINE}</code>
    </Alert>
  );
}

export default WorkerWarning;
